import { useDialog } from "~/src/modules/ui-kit";

import { Finder2 } from "../../../../../../modules/finder";
import * as UI from "../../../../../../modules/ui-kit";
import ComponentTypeCardContainer from "../../entities/component-type/ComponentTypeCardContainer";
import ComponentTypeFinderPlugin from "../../entities/component-type/ComponentTypeFinderPlugin";


export default function ComponentAdder(props) {
    const { bimClassID, disabled, onSelect } = props;

    const [Dialog, open] = useDialog();

    return (
        <>
            <UI.Button
                $size="large"
                disabled={ disabled }
                onClick={ open }
            >
                Add component
            </UI.Button>
            <Dialog>
                <Finder2>
                    <ComponentTypeFinderPlugin
                        Component={ ComponentTypeCardContainer }
                        bimClassID={ bimClassID }
                        onSelect={ onSelect }
                    />
                </Finder2>
            </Dialog>
        </>
    );
}
